import { ElementRef, Injectable, inject } from '@angular/core';
import { debounceTime, fromEvent, take } from 'rxjs';
import { WindowRef } from './window/window-ref';

export enum ClassSelector {
  INVALID_FORM_INPUT = 'form .ng-invalid:not([hidden])',
}

@Injectable()
export class ScrollService {
  private windowRef = inject(WindowRef);

  scrollToElement(
    classSelector: string | ClassSelector,
    elementRef: ElementRef,
    scrollToOptions?: ScrollToOptions,
    blurDebounceTime = 300,
    offset = -50,
  ): void {
    if (this.windowRef.nativeWindow && elementRef) {
      const element: HTMLElement =
        elementRef.nativeElement.querySelector(classSelector);
      if (element) {
        scrollToOptions = {
          behavior: 'smooth',
          top:
            this.windowRef.nativeWindow?.pageYOffset +
            element.getBoundingClientRect().top +
            offset,
          ...scrollToOptions,
        };
      }

      if (this.windowRef.document.activeElement) {
        const activeElement = this.windowRef.document
          .activeElement as HTMLElement;

        fromEvent(activeElement, 'blur')
          .pipe(debounceTime(blurDebounceTime), take(1))
          .subscribe(() => {
            this.windowRef.nativeWindow?.scrollTo(scrollToOptions);
          });
        activeElement.blur();
      } else {
        this.windowRef.nativeWindow?.scrollTo(scrollToOptions);
      }
    }
  }
}
